import { ListReducer, mergeEntities } from '../../store';

import { transformUserRecentProjectsAndContests } from './transformers';

export const navigationUserRecentProjectsAndContestsReducer: ListReducer<
  'navigationUserRecentProjectsAndContests'
> = (state = {}, action) => {
  switch (action.type) {
    case 'API_FETCH_SUCCESS':
      if (
        action.payload &&
        action.payload.ref.path[0] === 'navigationUserRecentProjectsAndContests'
      ) {
        const ref = action.payload.ref;
        const data = <any>action.payload.data;
        return mergeEntities<'navigationUserRecentProjectsAndContests'>(
          state,
          transformUserRecentProjectsAndContests(data),
          ref,
        );
      }
      return state;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/navigation/reducers/userRecentProjectsAndContests.ts